// eslint-disable-next-line import/no-cycle
import type { Fields } from "@vuex-orm/core";
import { Action } from "./ActionHierarchy";

import type { ActionWithDuration } from "./ActionTypes";

export class Pause extends Action implements ActionWithDuration {
  // This is the name used as module name of the Vuex Store.
  public static entity = "pauses";

  public static baseEntity = "actions";

  public readonly isBrowserAction = false;

  public static fields(): Fields {
    return {
      ...super.fields(),
      duration: this.number(1),
      // job: this.attr('')
    };
  }

  public declare duration: number;

  public static get humanName(): string {
    return "Delay";
  }

  public static isPlayable = false;

  public get initialPlayableTimestamp(): number | null {
    // This method returns the timestamp that the rrweb-player should display by default.
    return (
      (this.previousVisiblePlayableBrowserAction &&
        this.previousVisiblePlayableBrowserAction.endsAt) ||
      (this.nextVisiblePlayableBrowserAction && this.nextVisiblePlayableBrowserAction.startsAt)
    );
  }
}
